// Line Sorter Tool — sort lines of text alphabetically, numerically or by length.
import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const lineSorterTool: Tool = {
  id: "line-sorter",
  name: () => m.ls_tool_name(),
  description: () => m.ls_tool_description(),
  icon: "🔤",
  basePath: "/line-sorter",
  status: "stable",
  tags: ["text", "sort", "lines", "developer"],
  pages: [
    {
      name: () => m.ls_nav_main(),
      path: "/line-sorter",
      description: () => m.ls_nav_main_desc(),
      icon: "🔤",
    },
  ],
};
